import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ActivityIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'Announcement',
    href: '#announcement'
  }, {
    name: 'How it works',
    href: '#how-it-works'
  }, {
    name: 'Benefits',
    href: '#benefits'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="flex justify-between items-center" data-id="element-69">
          <div className="flex items-center gap-2" data-id="element-70">
            <div className="w-8 h-8 rounded bg-primary flex items-center justify-center" data-id="element-71">
              <ActivityIcon className="w-5 h-5 text-white" data-id="element-72" />
            </div>
            <span className="font-bold text-xl text-heading tracking-tight" data-id="element-73">
              ERPLogiFlow
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-74">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-primary transition-colors" data-id="element-75">
                {link.name}
              </a>)}
          </nav>

          <div className="hidden md:flex items-center" data-id="element-76">
            <button className="bg-accent hover:bg-accent-hover text-white px-5 py-2.5 rounded-md font-medium text-sm transition-colors shadow-sm" data-id="element-77">
              Request a Demo
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-78">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-79" /> : <MenuIcon className="w-6 h-6" data-id="element-80" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-81">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-slate-100 overflow-hidden" data-id="element-82">
            <div className="px-4 py-4 flex flex-col gap-4" data-id="element-83">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-84">
                  {link.name}
                </a>)}
              <button className="bg-accent text-white px-5 py-3 rounded-md font-medium text-base mt-2 w-full" data-id="element-85">
                Request a Demo
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}